import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FolderIcon from '@mui/icons-material/Folder';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import PropTypes from 'prop-types';

import { formatBytes } from '../../../utils/utils';

const FileList = ({ files, removeFile }) => {
  const handleRemove = (index) => {
    removeFile(index);
  };

  return files?.map((file, i) => (
    <ListItem key={file.path}>
      <ListItemAvatar>
        <Avatar>
          <FolderIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText primary={file.path} secondary={formatBytes(file.size)} />
      <ListItemSecondaryAction>
        <IconButton
          edge="end"
          aria-label="remove file"
          onClick={() => handleRemove(i)}
          size="large"
        >
          <DeleteOutlineIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  ));
};

FileList.propTypes = {
  files: PropTypes.array.isRequired,
  removeFile: PropTypes.func.isRequired,
};

export default FileList;
